module.exports = __webpack_public_path__ + "assets/b8d4adfefabc595f38b8a34b4e24656e.png";